import { EditOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { Button, Card, Tag } from "antd";
import React from "react";
import { $t } from "~/i18n.js";

import { MaintenanceStatusTag } from "~/pages/materiaal/materialTags.jsx";
import { DocumentFileList } from "./documentFileList.jsx";
import { OrderDeleteButtons } from "~/pages/admin/dto/components/OrderDeleteButtons.jsx";
import './MatChapterList.css';

export const MatChapterList = ({
  idx,
  loadingOrder,
  save_chapter_order,
  chapter,
  allChapters,
  documents,
  searchYear,
  setOpenChapter,
  readOnly,
  materialID,
}) => {
  return (
    <Card
      size="small"
      className="ChapterList"
      bordered={false}
      style={{
        maxWidth: 1000,
        width: "100%",
        borderTop: "2px solid #f0f0f0",
        borderRadius: 0,
        padding: 0,
      }}
      title={
        <p className="row" style={{ gap: 6 }}>
          <MaintenanceStatusTag maintenance_status={chapter.status} hideTag />
          {chapter.name}
          {!chapter.is_public && <EyeInvisibleOutlined />}
          
        </p>
      }
      extra={[
        chapter.is_archived && (
            <Tag key="archived" color="red" style={{ fontWeight: 400, fontSize: 11 }}>
              {$t("archief")}{" "}
            </Tag>
          ),
        !chapter.is_archived && chapter.tag && <Tag key="tag">{chapter.tag}</Tag>,

        !readOnly && (
          <OrderDeleteButtons
            loading={loadingOrder}
            task_index={idx}
            task={chapter}
            tasks={allChapters}
            saveTasks={(d) => save_chapter_order(d)}
            hasDelete={false}
          />
        ),
        !readOnly && (
          <Button
            key="edit"
            style={{ marginLeft: 6 }}
            icon={<EditOutlined />}
            size="small"
            shape="circle"
            onClick={() => setOpenChapter(chapter)}
          />
        ),
      ].filter((f) => f)}
    >
      <DocumentFileList
        readOnly={readOnly}
        documents={documents}
        chapter={chapter}
        allChapters={allChapters}
        materialID={materialID}
        searchYear={searchYear}
      />
    </Card>
  );
};
